import type { AxiosInstance } from "axios";
import { publicAxios } from "../config/axios";
import {
  dispatchEtaHardLockEvent,
  getEtaHardLockDetailFromError,
} from "./etaHardLock";

const attachedClients = new WeakSet<AxiosInstance>();

/**
 * Attach 423 ETA Hard lock handling to a specific axios instance.
 * Safe to call multiple times for the same instance.
 */
export function attachEtaHardLockInterceptor(instance: AxiosInstance): void {
  if (!instance || attachedClients.has(instance)) {
    return;
  }
  attachedClients.add(instance);

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const detail = getEtaHardLockDetailFromError(error);
      if (detail) {
        dispatchEtaHardLockEvent(detail);
      }
      return Promise.reject(error);
    },
  );
}

/**
 * Registers the Hard-lock interceptor on ORCA's shared axios clients.
 * Call after setupPublicAxios(); setupAuthAxios also attaches when auth client is created.
 */
export function setupEtaHardLockAxiosInterceptor(): void {
  if (publicAxios) {
    attachEtaHardLockInterceptor(publicAxios);
  }
}
